import type { CollectedValues } from "./types";

/**
 * Terminal entity ids for a resolved action — excludes intermediate walk picks
 * (e.g. deal → company → contact should yield only the contact id).
 */
export function resolveTerminalTargetIds(collected: CollectedValues): string[] {
  if (collected.bulkPick?.ids?.length) {
    return collected.bulkPick.ids;
  }

  const pickEntries = Object.entries(collected.picks).filter(
    (entry): entry is [string, string] =>
      typeof entry[1] === "string" && entry[1].length > 0,
  );

  if (pickEntries.length === 0) {
    return [collected.sourceId];
  }

  const terminalIndex = Math.max(...pickEntries.map(([index]) => Number(index)));
  const terminalId = collected.picks[terminalIndex];
  return terminalId ? [terminalId] : [pickEntries[pickEntries.length - 1][1]];
}
